import React, { useState, useEffect } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axios from '../../utils/axiosInstance';
import { toastSuccess, toastError } from '../../utils/alertHelper';

const MemberPolicy = () => {
  const [description, setDescription] = useState('');
  const [lastUpdated, setLastUpdated] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchPolicy();
    // eslint-disable-next-line
  }, []);

  const fetchPolicy = async () => {
    try {
      const res = await axios.get('/admin/api/policy');
      if (res.data && res.data.policy && res.data.policy.memberpolicy) {
        setDescription(res.data.policy.memberpolicy);
        setLastUpdated(res.data.policy.memberpolicyUpdatedAt || null);
      }
    } catch {
      toastError('Failed to fetch member policy');
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await axios.put('/admin/api/policy', { 
        memberpolicy: description 
      });
      setLastUpdated(res.data?.memberpolicyUpdatedAt || new Date().toISOString());
      toastSuccess('Member Policy updated successfully');
    } catch {
      toastError('Failed to update member policy');
    }
    setSaving(false);
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-3">Member Policy Description(Last updated on: {lastUpdated ? new Date(lastUpdated).toLocaleDateString() : 'Not updated yet'})</h3>
      <div className="mb-3 editor-wrapper">
        <label className="form-label">Description</label>
        <CKEditor
          editor={ClassicEditor}
          data={description || ''}
          onChange={(event, editor) => {
            const data = editor.getData();
            setDescription(typeof data === 'string' ? data : String(data || ''));
          }}
          config={{
            toolbar: [
              'heading', '|',
              'bold', 'italic', 'underline', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
              'undo', 'redo'
            ],
            height: 500
          }}
        />
      </div>
      <button
        className="btn btn-success"
        onClick={handleSave}
        disabled={saving}
      >
        {saving ? 'Saving...' : 'Save'}
      </button>
    </div>
  );
};

export default MemberPolicy;